import styled from "styled-components";
import { FiX, FiInfo } from "react-icons/fi";
import Dimenzije from "../../assets/images/dimenzije.png";

const TShirtSizeGuide = ({ isOpen, onClose, productDimensions }) => {
  // Koristi prosleđene dimenzije proizvoda
  const sizeData = productDimensions;

  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>
            <FiInfo />
            Vodič za veličine majici
          </Title>
          <CloseButton onClick={onClose}>
            <FiX />
          </CloseButton>
        </Header>

        <Content>
          {/* Prikaz majice */}
          <TShirtContainer>
            <TShirtImage>
              <FrontTShirt src={Dimenzije} />
            </TShirtImage>

            {/* Legenda */}
            <Legend>
              <LegendItem>
                <ColorBox $color="#ff6b35" />
                <span>A - Širina grudi (pola obima)</span>
              </LegendItem>
              <LegendItem>
                <ColorBox $color="#ff6b35" />
                <span>B - Dužina majice</span>
              </LegendItem>
              <LegendItem>
                <ColorBox $color="#ff6b35" />
                <span>C - Dužina rukava</span>
              </LegendItem>
            </Legend>
          </TShirtContainer>

          {/* Tabela veličina */}
          <SizeTable>
            <TableTitle>Tabela veličina</TableTitle>
            <Table>
              <thead>
                <tr>
                  <TableHeader>Veličina</TableHeader>
                  <TableHeader>A - Širina grudi</TableHeader>
                  <TableHeader>B - Dužina</TableHeader>
                  <TableHeader>C - Rukav</TableHeader>
                </tr>
              </thead>
              <tbody>
                {sizeData.map((row, index) => (
                  <TableRow key={row.size} $even={index % 2 === 0}>
                    <SizeCell>{row.size}</SizeCell>
                    <MeasurementCell>{row.chest} cm</MeasurementCell>
                    <MeasurementCell>{row.length} cm</MeasurementCell>
                    <MeasurementCell>{row.sleeve} cm</MeasurementCell>
                  </TableRow>
                ))}
              </tbody>
            </Table>
          </SizeTable>

          {/* Napomene */}
          <Notes>
            <h4>Napomene:</h4>
            <ul>
              <li>Sve mere su date u centimetrima</li>
              <li>Širina grudi je merena po najširem delu majice</li>
              <li>Dužina se meri od vrha ramena do dna majice</li>
              <li>Dužina rukava se meri od ramena do kraja rukava</li>
              <li>Preporučujemo da proverite mere pre naručivanja</li>
            </ul>
          </Notes>
        </Content>
      </Modal>
    </Overlay>
  );
};

export default TShirtSizeGuide;

// Styled components
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(8px);
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const Modal = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
  border-radius: 20px;
  width: 90%;
  max-width: 950px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5);
  border: 2px solid #ff6b35;
  animation: slideIn 0.4s ease;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 2px solid #ff6b35;
  background: linear-gradient(135deg, #ff6b35 0%, #e55a2b 100%);

  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      transparent 0%,
      #ff6b35 50%,
      transparent 100%
    );
  }
`;

const Title = styled.h2`
  margin: 0;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-size: 1.6rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;

  svg {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }
`;

const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.3);
  font-size: 1.2rem;
  cursor: pointer;
  color: white;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
    transform: rotate(90deg) scale(1.1);
    color: #ffffff;
  }
`;

const Content = styled.div`
  padding: 2.5rem;
  background: linear-gradient(
    180deg,
    rgba(255, 107, 53, 0.02) 0%,
    transparent 30%
  );
  color: #ffffff;
`;

const TShirtContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start;
  }
`;

const TShirtImage = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const FrontTShirt = styled.img`
  background: linear-gradient(135deg, #333 0%, #444 100%);
  border-radius: 15px;
  border: 2px solid rgba(255, 107, 53, 0.3);
  transition: all 0.3s ease;
  max-width: 100%;
`;

const Legend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: linear-gradient(135deg, #333 0%, #444 100%);
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 107, 53, 0.2);
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b, #ff6b35);
    border-radius: 15px 15px 0 0;
  }

  @media (min-width: 768px) {
    margin-left: 2rem;
  }
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.95rem;
  color: #ffffff;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    transform: translateX(5px);
    color: #ff6b35;
  }
`;

const ColorBox = styled.div`
  width: 24px;
  height: 24px;
  background: ${(props) => props.$color};
  border-radius: 6px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    border-color: rgba(255, 255, 255, 0.5);
  }
`;

const SizeTable = styled.div`
  margin-bottom: 3rem;
`;

const TableTitle = styled.h3`
  color: #ff6b35;
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 700;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(135deg, #333 0%, #444 100%);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
  border: 2px solid rgba(255, 107, 53, 0.2);
`;

const TableHeader = styled.th`
  background: linear-gradient(135deg, #ff6b35 0%, #e55a2b 100%);
  color: white;
  padding: 1.2rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: rgba(255, 255, 255, 0.3);
  }
`;

const TableRow = styled.tr`
  background: ${(props) =>
    props.$even ? "rgba(255, 107, 53, 0.05)" : "transparent"};
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 107, 53, 0.1);

  &:hover {
    background: rgba(255, 107, 53, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(255, 107, 53, 0.15);
  }

  &:last-child {
    border-bottom: none;
  }
`;

const SizeCell = styled.td`
  padding: 1.2rem;
  text-align: center;
  font-weight: 800;
  font-size: 1.2rem;
  color: #ff6b35;
  text-shadow: 0 1px 3px rgba(255, 107, 53, 0.3);
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    background: linear-gradient(180deg, #ff6b35, #e55a2b);
    border-radius: 0 3px 3px 0;
  }
`;

const MeasurementCell = styled.td`
  padding: 1.2rem;
  text-align: center;
  color: #ffffff;
  font-weight: 500;
  font-size: 0.95rem;
`;

const Notes = styled.div`
  background: linear-gradient(
    135deg,
    rgba(255, 107, 53, 0.1) 0%,
    rgba(44, 44, 44, 0.8) 100%
  );
  border: 2px solid #ff6b35;
  border-radius: 15px;
  padding: 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b, #ff6b35);
  }

  h4 {
    margin: 0 0 1.5rem 0;
    color: #ff6b35;
    font-size: 1.1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  ul {
    margin: 0;
    padding-left: 2rem;
    color: #cccccc;
  }

  li {
    margin-bottom: 0.8rem;
    font-size: 0.95rem;
    line-height: 1.5;
    transition: all 0.2s ease;

    &:hover {
      color: #ffffff;
      transform: translateX(5px);
    }
  }
`;
